var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.866 14.7194C18.4942 13.6793 18.9109 12.3638 18.9917 11.0621C19.043 10.2267 18.8549 9.34965 18.4475 8.52496C17.8085 7.22946 16.7108 6.50171 15.6504 5.79857C14.859 5.27391 14.1112 4.77848 13.5825 4.07072L13.4877 3.94456C13.1752 3.52914 12.8222 3.05833 12.7663 2.66291C12.7103 2.26287 12.3434 1.97823 11.9422 2.00131C11.5349 2.029 11.2192 2.36288 11.2192 2.76753V16.4764C10.5678 16.0856 9.76549 15.8456 8.88702 15.8456C6.7445 15.8456 5 17.2257 5 18.9228C5 20.6199 6.7445 22 8.88702 22C11.0296 22 12.774 20.6199 12.774 18.9228V9.95586C13.9417 10.3974 15.8526 11.5222 16.3781 14.1485C16.2801 14.2916 16.1869 14.4455 16.078 14.5686C15.7935 14.8871 15.8246 15.3733 16.148 15.6533C16.4683 15.9364 16.9596 15.9025 17.2441 15.584C17.4525 15.3502 17.6375 15.0763 17.8147 14.7901C17.8334 14.7686 17.8505 14.7455 17.866 14.7194Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.14eec40c73a6e9dcce5551094e667dfc.svg";
export { ForwardRef as ReactComponent };